import PropTypes from 'prop-types';
import LabeledBetImpl from './labeled-bet.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Labeled bet view displaying a bet type name and a stake input. Bet type names
 * can be of either Single, Double, Treble and Accumulator(x). The stake input will be given
 * a multiplier based on the number of bets in the betslip.
 *
 * @class LabeledBet
 * @private
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * LabeledBet prop types.
 *
 * @property {Mojito.Services.Betslip.types.Bet} bet - Bet.
 * @property {Mojito.Services.Betslip.types.BetStake} [betStake = {}] - Stake information.
 * @property {string} [currencyCode] - Currency code used to format currency values.
 * @property {boolean} [showStake] - True to show the stake input, false otherwise.
 * @property {boolean} [suspended = false] - Flag indicating whether the bet is suspended.
 * @property {boolean} [isEachWayAvailable = false] - True if each way toggle button should be shown, otherwise false.
 * @property {boolean} [isEachWayActivated = false] - True if each way toggle button should be activated.
 * @property {number} [singleBetCount = 0] - Number of single bets in the stake group.
 * @property {number} [bankerBetCount = 0] - Number of selected banker bets in the stake group.
 * @property {boolean} [hasErrors = false] - Flag to indicate if betslip has any bet specific errors that includes bet id.
 *
 * @memberof Mojito.Modules.Betslip.BetslipView.LabeledBet
 */
const propTypes = {
    bet: PropTypes.object.isRequired,
    betStake: PropTypes.object,
    currencyCode: PropTypes.string,
    showStake: PropTypes.bool,
    suspended: PropTypes.bool,
    isEachWayAvailable: PropTypes.bool,
    isEachWayActivated: PropTypes.bool,
    singleBetCount: PropTypes.number,
    bankerBetCount: PropTypes.number,
    hasErrors: PropTypes.bool,
};

const defaultProps = {
    // showStake's default value is set to true by default in the sub-component StakeInput,
    // so we can't set it to anything here without affecting that
    suspended: false,
    isEachWayAvailable: false,
    isEachWayActivated: false,
    singleBetCount: 0,
    bankerBetCount: 0,
    hasErrors: false,
    betStake: {},
};

export default UIView('LabeledBet', LabeledBetImpl, propTypes, defaultProps);
